module.exports = __webpack_public_path__ + "europa-20-raised_print.jpg?f72ab091b7a3dfb50ee7d7830b926ccf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-20-raised_print.jpg
// module id = 300
// module chunks = 0